export default "__VITE_ASSET__CmhOAHET__"